<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">租赁价格查询</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="品牌">
        <el-select class="form-input" v-model="Search.Brand" placeholder="请选择或输入品牌" clearable filterable>
          <el-option v-for="Brand in Brands" :key="Brand.Id" :label="Brand.Name" :value="Brand.Id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select class="form-input" v-model="Search.Model" placeholder="请选择或输入机型" clearable filterable>
          <el-option v-for="Model in Models" :key="Model.Id" :label="Model.Name" :value="Model.Id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select class="form-input" v-model="Search.Module" placeholder="请选择或输入模块" clearable filterable>
          <el-option v-for="Module in Modules" :key="Module.Id" :label="Module.Name" :value="Module.Id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" placeholder="请输入物料名称/物料编码" @keyup.enter.native="handleSearch()"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="handleSearch()" style="width: 120px">查询</el-button>
        <router-link to="/trust">
          <el-button type="primary" style="width: 140px">新建租赁申请单</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="main-content" slot="main-content">
      <el-table v-loading="IsLoading" element-loading-text="加载中" :data="tableData">
        <el-table-column label="物料名称/编码">
          <template scope="props">
            <p class="no-margin">{{props.row.Product.Name}}</p>
            <p class="no-margin">物料编码：{{props.row.Product.Code}}</p>
          </template>
        </el-table-column>
        <el-table-column label="品项" width="100">
          <template scope="props">
            <el-tag type="primary">{{props.row.Condition.Name}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="品牌" prop="Product.Brand.Name" width="100"></el-table-column>
        <el-table-column label="机型" prop="Product.Model.Name" width="160"></el-table-column>
        <el-table-column label="模块" prop="Product.Module.Name" width="120"></el-table-column>
        <!-- <el-table-column label="厂家编码" width="100"></el-table-column> -->
        <el-table-column label="固定租赁价格" width="160">
          <template scope="props">
            <div>
              <p class="no-margin" v-for="item in filterPrice(props.row.Lines)" :key="item.Id">
                {{checkEffectivedDate(item,item.RentalPrice)}}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="灵活租赁价格" width="120">
          <template scope="props">
            <div v-if="props.row.FlexibleTermPrice === 0">暂无价格</div>
            <div v-else>{{checkEffectivedDate(props.row,props.row.FlexibleTermPrice,3)}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </list-page-layout>
</template>

<script>
import Countdown from '@/components/common/Countdown'
import ListPageLayout from '@/components/common/ListPageLayout'
import ComplexGrid from '@/components/common/ComplexGrid'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        Product: null,
        Brand: null,
        Model: null,
        Module: null,
      },
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      total: 0,
      Brands: [],
      Models: [],
      Modules: [],
      IsLoading: false,
    }
  },
  methods: {
    handleSearch() {
      this.IsLoading = true
      const Query = o('ProductRentalPrice')
      let filters = []
      Query.expand('Product')
      Query.expand('Condition')
      Query.expand('Lines')
      if (this.Search.Brand) {
        filters.push(`Product/Brand/Id eq ${this.Search.Brand}`)
      }
      if (this.Search.Model) {
        filters.push(`Product/Model/Id eq ${this.Search.Model}`)
      }
      if (this.Search.Module) {
        filters.push(`Product/Module/Id eq ${this.Search.Module}`)
      }
      if (this.Search.Product) {
        if (this.Search.Product.includes(',')) {
          let conditions = this.Search.Product.split(',').map((value) => {
            return `(contains(Product/Name, '${value}') or contains(Product/Code, '${value}'))`
          })
          filters.push(conditions.join(' or '))
        } else {
          filters.push(`(contains(Product/Name, '${this.Search.Product}') or contains(Product/Code, '${this.Search.Product}'))`)
        }
      }
      // 读取首页租赁价格查询带过来的物料名称、编码【modifyby:zdx modifyon:2017-10-16】
      let pnames = this.$route.query.product
      if (pnames && pnames.length > 0) {
        let pnamearr = pnames.split(',')
        let _product = '('
        for (let i = 0; i < pnamearr.length; i++) {
          if (pnamearr[i].length > 0) {
            _product += `contains(Product/Name,'${pnamearr[i]}')
              or
              contains(Product/Code, '${pnamearr[i]}')`
            if (i < pnamearr.length - 1) {
              _product += ' or '
            }
            // filters.push(`(contains(Product/Name, '${pnamearr[i]}') or contains(Product/Code, '${pnamearr[i]}'))`)
          }
        }
        _product += ')'
        console.log(_product)
        filters.push(_product)
      }
      if (filters.length > 0) {
        Query.filter(filters.join(' and '))
      }
      Query.inlineCount()
      Query.skip((this.currentPage - 1) * this.pageSize)
      Query.top(this.pageSize)
      Query.get().then(({ data, inlinecount }) => {
        this.IsLoading = false
        this.tableData = data
        this.total = inlinecount
      }).fail((error) => {
        this.IsLoading = false
        this.$alert(error.message)
      })
    },
    handleChange(params) {
      this.currentPage = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    getBrand() {
      const Query = o('ProductBrand')
      Query.get().then(({ data }) => {
        this.Brands = data
      })
    },
    getModel() {
      const Query = o('ProductModel')
      Query.get().then(({ data }) => {
        this.Models = data
      })
    },
    getModule() {
      const Query = o('ProductModule')
      Query.get().then(({ data }) => {
        this.Modules = data
      })
    },
    filterPrice(list) {
      const filterList = list.filter(item => item.PeriodInMonths !== 3)
      return filterList.sort((a, b) => a.PeriodInMonths - b.PeriodInMonths)
    },
    /* 获取月份对应的租赁价格，如果传入month则显示固定月份，否则显示对应的月份 */
    checkEffectivedDate(item, price, month) {
      if (price === 0) {
        return '暂无价格'
      } else if (this.$moment(item.EffectivedDate).isAfter(this.$moment())) {
        return '￥' + price + `/${month | item.PeriodInMonths}个月`
      } else {
        return '暂无价格'
      }
    },
  },
  components: {
    ListPageLayout,
    ComplexGrid,
    Countdown,
  },
  created() {
    // 如果有搜索条件对象传入，则加载对应的信息
    if (this.$store.state.leasePriceParams) {
      this.Search.Product = this.$store.state.leasePriceParams.word
      this.Search.Model = this.$store.state.leasePriceParams.modelId
      // 清除vuex里的搜索对象
      this.$store.dispatch('CLEAR_LEASE_PRICE_PARAMS')
    }
    this.handleSearch()
    this.getBrand()
    this.getModule()
    this.getModel()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
</style>

<style lang="less">
.lease-list-page .el-tabs__active-bar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// LeasePriceListPage.vue?3c5543e9